/* Overland — IntersectionObserver-based section reveal.
   Adds .is-in-view to any element with [data-of-reveal] when it enters the
   viewport. Respects prefers-reduced-motion (the CSS rule below handles
   the visual fallback, but we also short-circuit JS work). */
(function () {
  const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
  const targets = document.querySelectorAll('[data-of-reveal]');
  if (!targets.length) return;

  if (mq.matches || !('IntersectionObserver' in window)) {
    targets.forEach((el) => el.classList.add('is-in-view'));
    return;
  }

  const io = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in-view');
          io.unobserve(entry.target);
        }
      }
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0.05 }
  );

  targets.forEach((el) => io.observe(el));
})();
